<script setup lang="ts">
// Blue Box pill (FOF home redesign 2026-11-02, spec §6). Replaces PortfolioPill's fund cycle (FOF → JH → BGA →
// Gold → …, paolo 2026-08-19 / FOF spec 2026-10-12): navigation is driven from the home page now, so the pill
// always goes home — "less clicks to reach any target". Blue Box is the app's new name. The page's own name sits
// beside it as a label in the fund's palette colour (gated funds included; the old pill-<slug> CSS knew only five).
import { computed } from 'vue'
import { FUND_REGISTRY, pageLabel, primaryPageHostname, type PageSlug } from './nav/fundConfig'
import { fundMeta } from './fundPalette'

const props = defineProps<{ portfolio: PageSlug }>()

const isHome = computed(() => props.portfolio === 'fof')
const label = computed(() => (isHome.value ? 'Home' : pageLabel(props.portfolio)))
const labelColour = computed(() => {
  if (isHome.value) return '#e0e0e0'
  const entry = FUND_REGISTRY[props.portfolio as keyof typeof FUND_REGISTRY]
  return entry ? fundMeta(entry.fund).color : '#e0e0e0'
})
// Same local/remote rule as the FOF rows (fofFormat.rowHref): ?portfolio= on localhost, the home host otherwise.
const homeHref = computed(() => {
  const host = typeof window !== 'undefined' ? window.location.hostname : ''
  return host === 'localhost' || host === '127.0.0.1' ? '?portfolio=fof' : `https://${primaryPageHostname('fof')}`
})
</script>

<template>
  <!-- @click.stop: the status bar toggles the integrity dropdown on click, like the pills around it. -->
  <span v-if="isHome" class="sb-pill bluebox-pill is-home" aria-current="page" data-testid="bluebox-pill" @click.stop>Blue Box</span>
  <a v-else :href="homeHref" class="sb-pill bluebox-pill" title="Blue Box home" data-testid="bluebox-pill" @click.stop>Blue Box</a>
  <span class="page-label" :style="{ color: labelColour }" data-testid="page-label">{{ label }}</span>
</template>

<style scoped>
.bluebox-pill { background: #1565c0; color: #fff; font-weight: 700; letter-spacing: 0.5px; text-decoration: none; cursor: pointer; }
.bluebox-pill:hover { filter: brightness(1.15); }
.bluebox-pill.is-home { opacity: 0.6; cursor: default; }
.page-label { font-weight: 700; letter-spacing: 0.3px; }
/* Phones: the status bar has no room for both the pill and the label (390 px overflowed by 2-8 px and every
   mobile smoke failed its document.scrollWidth check); the page names itself in its first heading anyway. */
@media (max-width: 600px) { .page-label { display: none; } }
</style>
